import io from 'socket.io-client';

const socket = new io.connect("http://0.0.0.0:10000/", {transports: ['websocket']});

// Stream Audio
let bufferSize = 2048,
  AudioContext,
  context,
  processor,
  input,
  globalStream;

const mediaConstraints = {
  audio: true,
  video: false
};

let AudioStreamer = {
  /**
   * @param {object} transcribeConfig Transcription configuration such as language, encoding, etc.
   * @param {function} onData Callback to run on data each time it's received
   * @param {function} onError Callback to run on an error if one is emitted.
   */
  initRecording: function (transcribeConfig, onData, onError, onChatResponse) {
    console.log("Initializing recording with config:", transcribeConfig);

    socket.emit('startGoogleCloudStream', {...transcribeConfig});
    AudioContext = window.AudioContext || window.webkitAudioContext;
    context = new AudioContext();
    processor = context.createScriptProcessor(bufferSize, 1, 1);
    processor.connect(context.destination);
    context.resume();
    
    const handleSuccess = function (stream) {
      console.log("Audio stream captured successfully");

      globalStream = stream;
      input = context.createMediaStreamSource(stream);
      input.connect(processor);

      processor.onaudioprocess = function (e) {
        microphoneProcess(e);
      };
    };

    navigator.mediaDevices.getUserMedia(mediaConstraints)
      .then(handleSuccess);

    if (onData) {
      socket.on('speechData', (response) => {
        onData(response.data, response.isFinal);
      });
    }
    
    socket.on('googleCloudStreamError', (error) => {
      if (onError) {
        onError('error');
      }
      closeAll();
    });

    
    socket.on('chatResponse', (response) => {
        if (onChatResponse) {
          onChatResponse(response.data);
        }
        socket.off('chatResponse');
    });
    

    socket.on('endGoogleCloudStream', () => {
      closeAll();
      socket.off('endGoogleCloudStream');
    });
  },

  stopRecording: function (isRestart, feedbackMessage = null) {
    console.log(`Stopping recording in utility_transcribe. Is it a restart? ${isRestart}`);

    if (feedbackMessage === null) {
      feedbackMessage = "Restart button - No feedback provided";
    }
    console.log("Feedback Message is", feedbackMessage)
    if (isRestart) {
      socket.emit('restart', feedbackMessage);
      console.log('feedback message is:', feedbackMessage)
    }
    else {
      socket.emit('endGoogleCloudStream');
    }
  
    closeAll();
  }
}

export default AudioStreamer;


// Helper functions
/**
 * Processes microphone data into a data stream
 *
 * @param {object} e Input from the microphone
 */
function microphoneProcess(e) {
  // console.log('Processing microphone data');

  const left = e.inputBuffer.getChannelData(0);
  const left16 = convertFloat32ToInt16(left);
  socket.emit('binaryAudioData', left16);
}

/**
 * Converts a buffer from float32 to int16. Necessary for streaming.
 * sampleRateHertz of 1600.
 *
 * @param {object} buffer Buffer being converted
 */
function convertFloat32ToInt16(buffer) {
  let l = buffer.length;
  let buf = new Int16Array(l / 3);

  while (l--) {
    if (l % 3 === 0) {
      buf[l / 3] = buffer[l] * 0xFFFF;
    }
  }
  return buf.buffer
}

/**
 * Stops recording and closes everything down. Runs on error or on stop.
 */
function closeAll() {
  // Clear the listeners (prevents issue if opening and closing repeatedly)
  console.log('Closing all recording operations');

  socket.off('speechData');
  socket.off('googleCloudStreamError');
  let tracks = globalStream ? globalStream.getTracks() : null;
  let track = tracks ? tracks[0] : null;
  if (track) {
    track.stop();
  }

  if (processor) {
    if (input) {
      try {
        input.disconnect(processor);
      } catch (error) {
        console.warn('Attempt to disconnect input failed.')
      }
    }
    processor.disconnect(context.destination);
  }
  if (context) {
    context.close().then(function () {
      input = null;
      processor = null;
      context = null;
      AudioContext = null;
    });
  }
}